module.exports = __webpack_public_path__ + "img/signature.9e11c907.png";